import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import { logwebvitals } from 'yoda-site-components/lib/middlewares/WebvitalsMiddleware';
import cjaAnalytics from 'yoda-core-components/lib/helpers/Analytics/CJAAnalytics';
import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import { buildCJALinkClick } from 'yoda-site-components/lib/analytics/CJAEventsHelper';
import * as ListActionTypes from '../actionTypes/MyListActionTypes';
import * as SavedListActionTypes from '../actionTypes/SavedListActionTypes';
import ProductListFilter from '../analytics/SavedListDetailsActionFilter';
import MyListActionFilter from '../analytics/MyListActionFilter';
import GiftRegistryActionFilter from '../analytics/GiftRegistryActionFilter';

const productListFilter = new ProductListFilter();
const myListActionFilter = new MyListActionFilter();
const giftRegistryActionFilter = new GiftRegistryActionFilter();
/**
 * This function will used only for redux middleware only to track tagging based on action request
 */
const AccountMiddleware = store => next => action => { // eslint-disable-line
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        const { enableCJAAnalytics = false } = store.getState()?.context?.featureFlags || {};

        /**
         * component can trigger an action only for tagging
         * action should contain analytics object as mandatory
         * @param analytics.type - {string}  - tagging key
         * @param analytics.JCPDL - {Object}  - required additional details for tagging event
         */
        try {
            switch (action.type) {
                case ListActionTypes.CREATE_LIST_SUCCESS_EVENT:
                    digitalData = {};
                    analyticsEventName = 'createNewList';
                    break;

                case ListActionTypes.CREATE_LIST_ERROR_EVENT:
                    digitalData = {
                        error: action.payload,
                    };
                    analyticsEventName = 'formError';
                    break;
                case SavedListActionTypes.DELETE_SAVED_LIST_SUCCESS_EVENT:
                    digitalData = {};
                    if ('ppId' in action.payload) {
                        digitalData.product = [
                            { productInfo: { productPPID: action.payload.ppId } },
                        ];
                        analyticsEventName = 'removeItemFromList';
                    } else {
                        analyticsEventName = 'deleteList';
                    }

                    break;
                case SavedListActionTypes.ANALYTICS_PRODUCTS_PAGE_LOAD:
                    digitalData = productListFilter.getPageLoadAttributes(store, action.payload);
                    analyticsEventName = 'digitalDataReady';
                    break;
                case ListActionTypes.DELETE_LIST_SUCCESS_EVENT:
                    digitalData = {};
                    analyticsEventName = 'deleteList';
                    break;
                case ListActionTypes.PAGE_LOAD_ANALYTICS_ACTION:
                    digitalData = myListActionFilter.getMyListPageDL(store, action.payload);
                    digitalData = myListActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = action.payload.trackEvent;
                    logwebvitals(store, digitalData);
                    break;
                case ListActionTypes.GIFT_REGISTRY_PAGE_LOAD_ACTION:
                    digitalData = giftRegistryActionFilter.getGiftRegistryPageDL(
                        store,
                        action.payload
                    );
                    digitalData = giftRegistryActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = action.payload.trackEvent;
                    break;
                case SavedListActionTypes.TRACK_ICON_EVENT:
                    digitalData = {
                        page: {
                            pageInfo: {
                                name: action.payload.trackEvent,
                            },
                        },
                    };
                    analyticsEventName = 'openModal';
                    break;
                default:
                    break;
            }
            if (analyticsEventName || digitalData) {
                console.info('digitalData -', digitalData);
                digitalData.dataVersion = 1;
                analytics.track(analyticsEventName, digitalData);
            }

            if (enableCJAAnalytics) {
                let cjaData = null;

                switch (action.type) {
                    case ListActionTypes.CREATE_LIST_SUCCESS_EVENT:
                        cjaData = buildCJALinkClick({
                            linkModuleName: 'createnewlist',
                            linkText: 'Add',
                        });
                        break;
                    case ListActionTypes.PAGE_LOAD_ANALYTICS_ACTION: {
                        const pageData = {
                            name: action.payload.pageName || '',
                            type: 'my lists',
                            siteSection: 'account',
                            category: { primary: 'account' },
                            tech: {
                                version: `apollo 1 ${new Date().getFullYear()} yoda account`,
                            },
                        };
                        const extra = { interactionName: 'regular_pageview' };
                        cjaData = {
                            eventName: 'pageView',
                            payload: buildCJAPageViewPayload(pageData, {}, extra),
                        };
                        break;
                    }
                    case SavedListActionTypes.TRACK_ICON_EVENT: {
                        cjaData = buildCJALinkClick({
                            linkId: 'at-open-modal',
                            linkText: action.payload.trackEvent,
                            linkModuleName: 'openModal',
                            linkRegion: 'modal',
                        });
                        break;
                    }
                    case ListActionTypes.DELETE_LIST_SUCCESS_EVENT:
                        cjaData = buildCJALinkClick({
                            linkModuleName: 'list:delete list',
                            linkText: 'deletelist',
                        });
                        break;
                    case SavedListActionTypes.DELETE_SAVED_LIST_SUCCESS_EVENT:
                        if ('ppId' in action.payload) {
                            cjaData = buildCJALinkClick({
                                linkModuleName: `list:removeitemfromlist:${action.payload.ppId}`,
                                linkText: 'removeItemFromList',
                            });
                        } else {
                            cjaData = buildCJALinkClick({
                                linkModuleName: 'list:delete list',
                                linkText: 'deletelist',
                            });
                        }
                        break;
                    default:
                        break;
                }

                if (cjaData) {
                    cjaAnalytics.track(cjaData.eventName, cjaData.payload);
                }
            }
        } catch (error) {
            console.log(error);
        }
    }
    if (action.type) {
        return next(action);
    }
};
export default AccountMiddleware;
